import { Button, Form, Input, Row, Col } from 'antd';
import React, { useEffect } from 'react'
import { Add_Object_Field_Value_Api, Update_Object_Field_Value_Api } from '../../API/ObjectFieldValueApi';
import { CheckOutlined, SaveOutlined} from '@ant-design/icons';

// =================================================================
export const EditObjectFieldValueDetailsComponent = ({ setLoading, showMessage, objectInstanceValues }) => {
    // =================================================================
    const [form] = Form.useForm();
    // =================================================================
    useEffect(() => {
        loadData()
    }, [objectInstanceValues.id]);
    // =================================================================
    const loadData = async () => {

        if (objectInstanceValues.id === "undefined")
            objectInstanceValues.id = "0";
        if (objectInstanceValues.value === "undefined")
            objectInstanceValues.value = "";
        form.setFieldsValue(objectInstanceValues);
    }
    // =================================================================
    const onSubmit = async (values) => {
            setLoading(true);
        try {
            values.isActive = true;
            let data;
            if (values.id == 0) {
                data = await Add_Object_Field_Value_Api(values);
                objectInstanceValues.id = parseInt(data.additional);
                objectInstanceValues.value = values.value;
                form.setFieldsValue(objectInstanceValues);
            }
            else
                data = await Update_Object_Field_Value_Api(values);

            setLoading(false);

            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful")
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error")
    };
    // ===============================================================
    return (

        <Form
            form={form}
            name={"form" + objectInstanceValues.id}
            onFinish={onSubmit}
            onFinishFailed={onFinishFailed}
        >
            <Row style={{margin:'3px 0px'}}>

                <Col xs={6} sm={6} md={6} lg={6} xl={6} >
                    <Form.Item
                        name="fieldTitle"
                        style={{ marginBottom: '0px',marginLeft:'5px'}}
                        rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                    >
                        <Input className='noBorder' style={{ backgroundColor: 'transparent' }} readOnly={true} />
                    </Form.Item>
                </Col>
                <Col xs={12} sm={14} md={14} lg={14} xl={14}>
                    <Form.Item
                        name="value"
                        style={{ marginBottom: '0px'}}
                        rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                    >
                        <Input placeholder='مقدار' />
                    </Form.Item>
                </Col>
                <Col xs={6} sm={4} md={4} lg={4} xl={4} style={{marginTop:'5px',textAlign:'left' }}>
                    <Button className='btn-primary' htmlType="submit" style={{width:'98%'}}>
                    <CheckOutlined />
                        ذخیره
                    </Button>
                </Col>


                <Form.Item
                    name="id"
                    hidden={true}
                >
                </Form.Item>

                <Form.Item
                    name="fieldId"
                    hidden={true}
                >
                </Form.Item>


                <Form.Item
                    name="objectInstanceTitle"
                    hidden={true}
                >
                </Form.Item>
                <Form.Item
                    name="objectInstanceId"
                    hidden={true}
                >
                </Form.Item>
            </Row>

        </Form>

    )
}
